import { useDialog } from "lib/@hooks/useDialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { navigate } from "lib/routes/navigate"
import { createSkillMap } from "routes/skill-mapper/controller/create-skill-map"
import { CreateSkillMapDialog } from "./create-skill-map-dialog"

export function useCreateSkillMap({ navigateOnCreate = true, regimeId } = {}) {
    const openDialog = useDialog(<CreateSkillMapDialog />, { maxWidth: "sm", fullWidth: true })

    return handleCreate

    async function handleCreate() {
        const result = await openDialog({ regimeId })
        if (!result) return null
        const params = {
            name: result.name,
            description: result.description || "",
            startingPoint: result.startingPoint,
            regimeId: result.regimeId || regimeId || null,
        }
        if (result.startingPoint === "existing") {
            params.sourceSkillMapId = result.sourceSkillMapId?.value ?? result.sourceSkillMapId
        }
        const created = await busyWhile(createSkillMapWithParams, "Creating skill map...")
        if (created?.id && navigateOnCreate) {
            navigate(`/app/optimiser/skill-mappings/${created.id}?getStarted=true`)
        }
        successSnackbar(`Skill map "${result.name}" created`)
        return created ? { ...created, name: created.name ?? result.name } : null

        function createSkillMapWithParams() {
            return createSkillMap(params)
        }
    }
}
